import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Tag } from 'antd'

import {
  getMemberStatusTextMap,
  MemberStatus
} from '../../enums/MemberStatus'

import { MemberStatusTagProps } from './interface'

export const MemberStatusTag = ({
  memberStatus,
  hideSuccessStatus = true
}: MemberStatusTagProps) => {
  const memberStatusMap = getMemberStatusTextMap(memberStatus)

  return hideSuccessStatus &&
    memberStatus === MemberStatus.SUCCESS ? null : (
    <Tag color={memberStatusMap.color}>
      <ExclamationCircleOutlined />
      {memberStatusMap.text}
    </Tag>
  )
}
